import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import Compressor from "compressorjs";
import { Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import async from "async";

import { useAppStore } from "../../providers/AppStoreProvider";
import { useAPI } from "../../providers/ApiProvider";
import { TOASTIFY_OPTIONS } from "../../config/ReactToastify";

import { uploadImage } from "../../utils/upload";

export const CreateComment = observer(({ parentId, comment, onSubmit, onCancel, trigger }) => {
  const store = useAppStore();
  const api = useAPI();
  const imageRef = useRef();
  const contentRef = useRef();
  const [imageUrl, setImageUrl] = useState();
  const [thumbnailUrl, setThumbnailUrl] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (comment) {
      contentRef.current.innerText = comment.content;
      setImageUrl(comment.image_url);
      setThumbnailUrl(comment.thumbnail_url);
    }
  }, []);

  const fileChangeHandler = (e) => {
    const file = e.target.files[0];

    async.parallel(
      {
        image(callback) {
          new Compressor(file, {
            quality: 0.6,
            convertSize: 100000,
            mimeType: "auto",
            success: (result) => {
              setImageUrl(URL.createObjectURL(result));
              uploadImage(result, (event) => {
                const percentComplete = Math.round((100 * event.loaded) / event.total);
              })
                .then((res) => {
                  setImageUrl(res.data.link);
                  callback(null, res.data.link);
                })
                .catch(() => {
                  callback("error image");
                })
                .finally(() => {});
            },
            error: (err) => {
              callback("error image");
            },
          });
        },
        thumbnail(callback) {
          new Compressor(file, {
            quality: 0.8,
            convertSize: 100000,
            maxWidth: 300,
            mimeType: "auto",
            success: (result) => {
              setThumbnailUrl(URL.createObjectURL(result));
              uploadImage(result, (event) => {
                const percentComplete = Math.round((100 * event.loaded) / event.total);
              })
                .then((res) => {
                  setThumbnailUrl(res.data.link);
                  callback(null, res.data.link);
                })
                .catch((e) => {
                  console.log(e);
                  callback("error thumbnail");
                })
                .finally(() => {});
            },
            error: (err) => {
              console.log(err);
              showError("Nén ảnh đại diện lỗi");
              callback("error thumbnail");
            },
          });
        },
      },
      (err, results) => {
        if (err) {
          console.log(err);
          toast.error("Không đăng tải được ảnh", TOASTIFY_OPTIONS);
          setImageUrl("");
          setThumbnailUrl("");
          return;
        }
      },
    );
  };

  const fileRemoveHandler = () => {
    imageRef.current.value = "";
    setImageUrl("");
    setThumbnailUrl("");
  };

  const keyDownHandler = (e) => {
    if (!loading) {
      if (e.keyCode === 27 && onCancel) onCancel();
      if (e.keyCode === 13) {
        e.preventDefault();
        if (contentRef.current.innerText || thumbnailUrl) {
          setLoading(true);
          createCommentHandler();
        }
      }
    } else {
      e.preventDefault();
    }
  };

  const createCommentHandler = () =>
    onSubmit
      ? onSubmit({
          content_comment: contentRef.current.innerText,
          time: store.currentTime,
          thumbnail_url: thumbnailUrl,
        })
      : api
          .callApi("createComment", {
            body: {
              lesson_id: store.currentLesson.id,
              content_comment: contentRef.current.innerText,
              time: store.currentTime,
              image_url: imageUrl,
              thumbnail_url: thumbnailUrl,
              parent_id: parentId,
            },
          })
          .then((res) => {
            store.createComment(res.data.comment);
            fileRemoveHandler();
            contentRef.current.innerHTML = "";
            setLoading(false);
          });
  return (
    <div className="create-comment comment d-flex flex-row mt-3">
      <div>
        <div className="avatar-lg rounded-circle overflow-hidden me-2 my-1">
          <img src={store.user?.avatar_url} className="w-100" />
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="input rounded-20">
          <div className="d-flex flex-row align-items-center justify-content-between p-2 ps-3">
            <Form.Control
              as="div"
              ref={contentRef}
              role="textbox"
              contentEditable
              aria-multiline="true"
              placeholder={`${parentId ? "Trả lời" : "Viết"} bình luận`}
              autoFocus={trigger}
              onKeyDown={keyDownHandler}
              className="textarea border-0 bg-transparent shadow-none me-3 p-1 ps-2"
            />
            <div className="comment-actions d-flex flex-row text-black-50 me-1">
              {loading && (
                <div
                  className="comment-action d-flex align-items-center me-1 p-1 px-2"
                  aria-hidden="true"
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </div>
              )}

              <div
                role="button"
                className="comment-action d-flex align-items-center me-1 p-1 px-2"
                aria-hidden="true"
                onClick={() => imageRef.current.click()}
              >
                <i className="fa-light fa-image fa-lg" />
              </div>
            </div>
            <input
              ref={imageRef}
              type="file"
              accept="image/*"
              className="d-none"
              onChange={fileChangeHandler}
            />
          </div>

          {thumbnailUrl && (
            <div className="d-flex my-2 px-4 pb-4">
              <div className="preview-img rounded-10 position-relative">
                <img className="rounded-10" src={thumbnailUrl} width="300" />
                <div
                  role="button"
                  className="close btn btn-sm rounded position-absolute end-0 top-0 m-3"
                  onClick={fileRemoveHandler}
                >
                  <i className="fa-solid fa-xmark" />
                </div>
              </div>
            </div>
          )}
        </div>
        {onCancel && <small className="d-block text-secondary mt-2 ps-4">Ấn ESC để Huỷ</small>}
      </div>

      {/* <div>
          <div
            role="button"
            className="comment-action d-flex align-items-center rounded-pill ms-2 p-3 text-black-50"
            onClick={createCommentHandler}
          >
            <i className="fa-regular fa-paper-plane-top" />
          </div>
        </div> */}
    </div>
  );
});
